import { render, staticRenderFns } from "./order_xbd_card.vue?vue&type=template&id=2480388e&scoped=true&"
import script from "./order_xbd_card.vue?vue&type=script&lang=js&"
export * from "./order_xbd_card.vue?vue&type=script&lang=js&"
import style0 from "./order_xbd_card.vue?vue&type=style&index=0&id=2480388e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480388e",
  null
  
)

export default component.exports